module.exports = __webpack_public_path__ + "img/power2.cca3e683.png";